import React from 'react';
import { G, Path } from 'react-native-svg';

import { IconDef } from './types';

export const AlertTriangle: IconDef = {
  svg: (
    <G>
      <Path
        d="M9.9998 7.50001V10.8333M9.9998 14.1667H10.0081M8.8459 3.24311L1.99183 15.082C1.61166 15.7386 1.42157 16.0669 1.44967 16.3364C1.47417 16.5715 1.59731 16.785 1.78844 16.924C2.00757 17.0833 2.38696 17.0833 3.14573 17.0833H16.8539C17.6126 17.0833 17.992 17.0833 18.2112 16.924C18.4023 16.785 18.5254 16.5715 18.5499 16.3364C18.578 16.0669 18.3879 15.7386 18.0078 15.082L11.1537 3.24311C10.7749 2.58881 10.5855 2.26166 10.3384 2.15178C10.1228 2.05593 9.87677 2.05593 9.66122 2.15178C9.41411 2.26166 9.22471 2.58881 8.8459 3.24311Z"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </G>
  ),
  svgStyles(color) {
    return {
      stroke: color,
      viewBox: '0 0 20 20',
    };
  },
};
